import API from './API.js';
import axios from 'axios'

export default class MasterTeachers extends API {
    constructor() {
        super('masterTeachers');
    }
    //masterTeachers/makeSupervisor
    async MakeSupervisor(params) {
        const response = await axios.get(`/masterTeachers/makeSupervisor`, { params })
        return response.data
    }
    // /masters
    async Masters(params) {
        const response = await axios.get(`/masterTeachers/masters`, { params })
        return response.data
    }
    async getRole(current_user_id,masterId) {
        const response = await axios.get(`/masterTeachers/getRole/${current_user_id}/${masterId}`)
        return response.data
    }
    async getGeneralRole(current_user_id) {
        const response = await axios.get(`/masterTeachers/getGeneralRole/${current_user_id}`)
        return response.data
    }
}
